type FieldConfig = {
  name: string
  label: string
  required: boolean
  numericOnly?: boolean
  allowAllChars?: boolean
  maxLength?: number
}

type FieldSection = {
  title: string
  fields: FieldConfig[]
}

export const COMPANY_EDIT_SECTIONS: FieldSection[] = [
  {
    title: 'Контактные данные',
    fields: [
      { name: 'lastName', label: 'Фамилия', required: true, maxLength: 100 },
      { name: 'firstName', label: 'Имя', required: true, maxLength: 100 },
      {
        name: 'fatherName',
        label: 'Отчество',
        required: false,
        maxLength: 100,
      },
    ],
  },
  {
    title: 'Данные компании',
    fields: [
      {
        name: 'companyName',
        label: 'Название компании',
        required: true,
        allowAllChars: true,
        maxLength: 128,
      },
      {
        name: 'kpp',
        label: 'КПП',
        required: false,
        numericOnly: true,
        maxLength: 9,
      },
      {
        name: 'ogrn',
        label: 'ОГРН',
        required: true,
        numericOnly: true,
        maxLength: 15,
      },
    ],
  },
  {
    title: 'Руководитель',
    fields: [
      {
        name: 'directorFullName',
        label: 'ФИО руководителя',
        required: true,
        maxLength: 100,
      },
      {
        name: 'directorPosition',
        label: 'Должность руководителя',
        required: true,
        maxLength: 128,
      },
    ],
  },
]
